import type { ReactNode } from "react"
import { Label } from "../../reusable/Label"

type FieldRowProps = {
  label: ReactNode
  children: ReactNode
  badges?: ReactNode
  erpIndicator?: ReactNode
  isFirst?: boolean
}

export const FieldRow = ({
  label,
  children,
  badges,
  erpIndicator,
  isFirst = false,
}: FieldRowProps) => {
  const borderClass = isFirst ? "" : "border-t border-base"

  return (
    <div
      className={`bg-base grid grid-cols-[1fr_106px_82px_185px] items-stretch px-4 ${borderClass}`}
    >
      <Label className="label-sm font-medium text-fg-base pr-3 py-2 flex items-center">
        {label}
      </Label>
      <div className="flex items-center justify-end gap-2 flex-wrap border-r border-base px-3 py-2">
        {badges}
      </div>
      <div className="flex items-center justify-start border-r border-base px-3 py-2 overflow-hidden">
        <span className="truncate">{erpIndicator}</span>
      </div>
      <div className="pl-3 py-2 flex items-center">{children}</div>
    </div>
  )
}
